import Vue from 'vue'
import Router from 'vue-router'
import PageLogin from './views/PageLogin.vue'
import PageHome from './views/PageHome.vue'
import PageUsers from './views/PageUsers.vue'
import PageAccounts from './views/PageAccounts.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login/:reset?', component: Vue.component('PageLogin', PageLogin), meta: {navtop: false, navleft: false, condition: vm => true} },
    { path: '/home', component: Vue.component('PageHome', PageHome), meta: { navtop: true, navleft: true, condition: vm => vm.accounts && vm.accounts.keys()} },
    { path: '/users', component: Vue.component('PageUsers', PageUsers), meta: { navtop: false, navleft: false, condition: vm => vm.accounts && vm.accounts.keys() } },
    { path: '/accounts', component: Vue.component('PageAccounts', PageAccounts), meta: { navtop: false, navleft: false, condition: vm => vm.accounts && vm.accounts.keys() } },
    { path: '/', redirect: '/home' },
  ],
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact',
})

router.beforeEach((to, from, next) => {
  if (!window.vm) return next()
  if (to.path && to.path.slice(0,8) === "/__/auth") {
    console.log('Auth link dont redirect')
    return next()
  }
  const authorized = vm.check_route(to)
  if (!authorized) return vm.$router.push({path: '/login', query: {'from': from.fullPath}})
  return next()
})
export default router
